import { Box } from "@mui/material"
export const Footer = () => {
    return (
        <Box sx={{ backgroundColor: '#8fb5d7', textAlign: "center", position: "fixed", bottom: 0, width: '100%', fontSize: '12px', color: '#eee', zIndex:100 }}>
            ShowtimeANAFIBJ v1.160 - Powered by Eurika - &#169; {new Date().getFullYear()}
        </Box>
    )
}